import React from 'react';
import './App.scss';

import Session from './Session';
/*
absolute
bg-blue-200
bg-gray-100
bg-info/20
bg-secondary/20
bg-info/50
bg-white/70
borde
border
border-2
border-b-2
border-b-5
border-error
border-info
border-secondary
border-success
bottom-0
bottom-5
btn
btn-circle
btn-square
file-input
flex
flex-col
flex-wrap
font-bold
font-semibold
gap-0
gap-5
grid
grid-cols-1
grid-cols-12
grid-cols-2
grid-cols-3
grid-cols-4
grid-cols-5
grid-cols-6
grid-rows-1
grid-rows-12
grid-rows-2
grid-rows-3
grid-rows-4
grid-rows-5
grid-rows-6
h-full
hover:hidden
hover:opacity-90
items-center
justify-around
justify-center
justify-end
justify-items-center
left-0
left-2
lg:grid-cols-4
m-0
mb-4
md:grid-cols-3
min-h-100
mt-2
opacity-50
outline-none
p-0
p-1
p-2
p-3
p-4
relative
right-0
right-2
rounded
shadow
sm:grid-cols-2
text-4xl
text-sm
text-xl
top-1/2
-translate-y-1/2
w-full
xl:grid-cols-6
z-10
*/

import createT from 'T';
const T = createT();
T({});

import Router from './Router';
import { routes } from './routes';

const DEBUG = false;

const App = () => {
  return (
    <div className='h-screen w-screen overflow-hidden flex flex-col'>
      {DEBUG ? (
        <Test />
      ) : (
        <Session>
          <GraphQlProvider>
            <Router routes={routes} />
          </GraphQlProvider>
        </Session>
      )}
    </div>
  );
};

import GraphQlProvider, {
  UploadCreatedDocument,
  UploadUpdatedDocument,
  useUpdatedListener,
  useCreatedListener,
} from '@/graphql';

import { useQuery, gql } from 'urql';
import { useState, useEffect } from 'react';
const testQ = gql`
  query {
    testField
  }
`;

const Test = () => {
  const [status, setStatus] = useState('INIT');
  const isINIT = status === 'INIT';
  const isFETCHING = status === 'FETCHING';
  const isDONE = status === 'DONE';

  const [result, redo] = useQuery({
    query: testQ,
  });
  const { data, fetching, error } = result;
  console.log('SHARE', result.stale, status, error);
  window.gql = result;
  useEffect(() => {
    return;
    const t = setInterval(() => console.log('SHARE REDO') || redo(), 1000); // ne fait rien avec cacheExchange
    return () => clearInterval(t);
  }, [redo]);

  useEffect(() => {
    if (fetching) {
      setStatus('FETCHING');
    }
  }, [fetching]);
  useEffect(() => {
    if (isFETCHING && !!fetching) {
      setStatus('DONE');
    }
  }, [isFETCHING, fetching]);
  const created = useCreatedListener({ query: UploadCreatedDocument });
  const updated114 = useUpdatedListener({
    query: UploadUpdatedDocument,
    variables: { id: 114 },
  });
  console.log('CREATED', created);
  console.log('UPDATED 114', updated114);
  return (
    <div>
      {status} - {error ? error.message : JSON.stringify(data, undefined, 2)}
    </div>
  );
};

export default App;
